import React, { memo, useCallback, useState } from "react";
import moment from "moment";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";
import "./List.css";

const backend = await new Backend().init();

function ListCard({ item, userType, reload }) {
  const {
    id,
    account_name,
    account_number,
    account_ifsc,
    type,
    bank,
    upi_id,
    qr_name,
    master_username,
    super_username,
    status,
    date_created,
  } = item;

  const [openClearModal, setOpenClearModal] = useState(false);
  const [tpassword, setTpassword] = useState("");
  const [loading, setLoading] = useState(false);

  // 🔹 Clear data logic
  const handleBankAccount = async () => {
    if (!tpassword) {
      toast.error("Please enter transaction password");
      return;
    }

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      bank_id: id,
      tpassword,
    };

    try {
      setLoading(true);
      const res = await backend.update_bank_account(data);

      if (res?.error === "False") {
        setOpenClearModal(false);
        toast.success(res?.message || "User data cleared successfully");
        reload();
      } else {
        toast.error(res?.message || "Failed to clear data");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error clearing user data");
    } finally {
      setLoading(false);
      setTpassword("");
    }
  };

  const handleSuperEdit = useCallback(() => {
    window.user_id = item.super_id;
    window.openeditSuper?.();
  }, [item.super_id]);

  const handleMasterEdit = useCallback(() => {
    window.user_id = item.master_id;
    window.masterModalOpen?.();
  }, [item.master_id]);
  return (
    <>
      <div className="menuContainer addHight text">
        {userType === 1 && (
          <div
            onClick={handleSuperEdit}
            className={`menuUsername ${userType === 1 ? "small" : null} `}
          >
            <div className="user_id">{super_username}</div>
          </div>
        )}

        {(userType === 1 || userType === 2) && (
          <div
            onClick={handleMasterEdit}
            className={`menuUsername ${userType === 1 ? "small" : null} `}
          >
            <div className="user_id">{master_username}</div>
          </div>
        )}

        <div className={`menuUsername`}>{account_name}</div>
        <div className={`menuUsername`}>{account_number}</div>
        <div className={`menuUsername`}>{account_ifsc}</div>
        <div className={`menuUsername`}>{type}</div>
        <div className={`menuUsername`}>{bank}</div>
        <div className={`menuUsername`}>{upi_id}</div>
        <div className={`menuUsername`}>{qr_name}</div>

        <div className="menuDate flex flex-col items-center justify-center">
          <div className="extraSmall">
            {moment(date_created).format("DD-MM-YYYY")}
          </div>
          <div className="small">{moment(date_created).format("HH:mm:ss")}</div>
        </div>

        <div className="menuName">
          <button
            onClick={()=>setOpenClearModal(true)}
            className={`${status === 0 ? "bg-[var(--sell)]" : "bg-[var(--primary)]"}  relative flex items-center justify-center gap-1 px-2 py-1 text-xs font-medium uppercase rounded-md transition-all duration-300 cursor-pointer hover:opacity-80 text-white border-2 border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.4)]`}
          >
            {status === 0 ? "DEACTIVE" : "ACTIVE"}
          </button>
        </div>
      </div>

      {/* 🔥 CLEAR MODAL */}
      {openClearModal && (
        <div
          className="customModalOverlay"
          onClick={() => setOpenClearModal(false)}
        >
          <div className="customModal" onClick={(e) => e.stopPropagation()}>
            <h3 className="customModalTitle">⚠️ Clear Data</h3>
            <p className="customModalWarning">
              This action will {status === 0 ? "Active" : "Deactive"} this Bank
              Account <b>{account_name}</b>.
            </p>

            <input
              type="password"
              placeholder="Enter Transaction password"
              value={tpassword}
              onChange={(e) => setTpassword(e.target.value)}
              disabled={loading}
              className="customInput"
            />

            <div className="customModalButtons">
              <button
                className="dropbtnNavSub white sell"
                onClick={() => setOpenClearModal(false)}
                disabled={loading}
              >
                Cancel
              </button>

              <button
                className="dropbtnNavSub white primary"
                onClick={handleBankAccount}
                disabled={loading}
              >
                {loading ? "Clearing..." : "Confirm Clear"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default memo(ListCard);
